import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import ButtonsRow from 'components/ButtonsRow';
import HorizontalDivider from 'components/HorizontalDivider';

export interface TreeFooterProps extends React.ComponentPropsWithRef<'div'> {
  /** Component(s) in the footer area. Consider using `Button`. */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: {
    TREE: Record<string, unknown>;
  }
}

/** Footer of the Tree, usually for adding one or more buttons. Any other props will be provided to the root element. */
const TreeFooter = React.forwardRef<HTMLElement, TreeFooterProps>((props: TreeFooterProps, ref) => getContext(({ theme }) => {
  const {
    children,
    theme: propTheme,
    ...otherProps
  } = props;
  // transform tree divider theme to divider theme for backward compatibility
  const userTheme = {
    color: undefined
  };
  userTheme.color = propTheme && propTheme.TREE && propTheme.TREE.divider;
  const resolvedTheme = _merge({}, theme.TREE, userTheme);
  return (
    <>
      <HorizontalDivider theme={resolvedTheme} />
      <ButtonsRow
        ref={ref}
        {...otherProps}
      >
        {children}
      </ButtonsRow>
    </>
  );
}));

TreeFooter.displayName = 'TreeFooter';

TreeFooter.defaultProps = {
  theme: undefined,
};

export { TreeFooter as default };
